import { Platform } from '@round/api';
import React from 'react';
import styles from './BookingSummary.module.css';
import { ReactComponent as TiktokIcon } from '../../../../../assets/TiktokIcon.svg';
import { ReactComponent as InstagramIcon } from '../../../../../assets/InstagramIcon.svg';
import { OptionsContext } from '../../../../../contexts/OptionsContext';
import useNonNullContext from '../../../../../hooks/useNonNullContext';
import { Skeleton } from '@round/ui-kit';

type BookingSummaryProps = {
    currencyId: number | undefined;
    totalCost: number | null;
    totalCreators: number | null;
    platforms: Platform[];
    loading: boolean;
};

const BookingSummary = ({ currencyId, totalCost, totalCreators, platforms, loading }: BookingSummaryProps) => {
    const { currencies } = useNonNullContext(OptionsContext);
    const currencySymbol = currencies.find((curr) => curr.id === currencyId)?.symbol;

    const totalCostDisplayValue = totalCost ? `${currencySymbol}${totalCost}` : '-';
    const totalCreatorsDisplayValue = totalCreators || '-';

    const platformIcons = (
        <>
            {platforms.includes('INSTAGRAM') && (
                <div className={styles.platformIconContainer}>
                    <InstagramIcon className={styles.platformIcon} />
                </div>
            )}
            {platforms.includes('TIKTOK') && (
                <div className={styles.platformIconContainer}>
                    <TiktokIcon className={styles.platformIcon} />
                </div>
            )}
        </>
    );
    return (
        <div className={styles.barWrapper}>
            <div className={styles.detailContainer}>
                <span className={styles.detailTitle}>Total Cost</span>
                {loading ? <Skeleton /> : <span className={styles.detailValue}>{totalCostDisplayValue}</span>}
            </div>
            <div className={styles.detailContainer}>
                <span className={styles.detailTitle}>Creators</span>
                {loading ? <Skeleton /> : <span className={styles.detailValue}>{totalCreatorsDisplayValue}</span>}
            </div>
            <div className={styles.detailContainer}>
                <span className={styles.detailTitle}>Platforms</span>
                {loading ? <Skeleton /> : <div className={styles.platformsRow}>{platformIcons}</div>}
            </div>
        </div>
    );
};

export default BookingSummary;
